import {required, requiredIf} from 'vuelidate/lib/validators'
import { notOlderThanTwoYears, notFutureDate} from "@/validations/date-validation";

const requiredIfCS = requiredIf((vm) => {
  let list = [1,16];
  return !!list.includes(vm.deliveryManner)
});

const requiredIfInduced = requiredIf((vm) => {
  return vm.isInduced === true
});

const requiredIfAnyDeath = requiredIf((vm) => {
  return vm.motherCondition === 3 ||
    (vm.infantsNumber > 0 && Array.isArray(vm.neonatal) && vm.neonatal.reduce((acc, item) => {
      if ([2,3,4,5,6].includes(item.status)) {
        return true
      } else {
        return acc
      }
    }, false))
})

const requiredDeliveryIndication = requiredIf((vm) => {
  let csList = [1];
  let forcepsList = [5,6];
  let vacuumList = [];
  let list = csList.concat(forcepsList, vacuumList);
  return !!list.includes(vm.deliveryManner)
});

const requiredIfExactAOG = requiredIf((vm) => {
  return vm.deliveryAOGType === 1;
});


const requiredIfInfantHasAnomaly = requiredIf((vm) => {
  return vm.anomalies === true;
});

const requiredIfInfantDeath = requiredIf((vm) => {
  return [2,3,4,5,6].includes(vm.status);
});

const requiredIfOBAndDelivered = requiredIf((vm) => {
  return vm.isPregnancy && vm.isDelivered;
});


export default {
  deliveryDate: {
    required,
    notFuture: notFutureDate,
    notTooOld: notOlderThanTwoYears,
  },
  deliveryAOG: {
    required
  },
  deliveryWeeks: {
    requiredIf: requiredIfExactAOG
  },
  deliveryDays: {
    requiredIf: requiredIfExactAOG
  },
  deliveryManner: {
    required
  },
  // Complicated Pregnancy
  isInduced: {
    required
  },
  inducedIndication: {
    requiredIf: requiredIfInduced
  },
  inducedMethod: {
    requiredIf: requiredIfInduced
  },
  inducedComplication: {
    requiredIf: requiredIfInduced
  },
  deathReviewed: {
    requiredIf: requiredIfAnyDeath
  },
  primaryRepeat: {
    requiredIf: requiredIfCS
  },
  incision: {
    requiredIf: requiredIfCS
  },
  CSBilateralSalpingectomy: {
    requiredIf: requiredIfCS
  },
  CSBTL: {
    requiredIf: requiredIfCS
  },
  deliveryIndication: {
    requiredIf: requiredDeliveryIndication
  },
  isTOLAC: {
    requiredIf: requiredIfOBAndDelivered
  },
  neonatal: {
    $each: {
      pediatricAge    : { required },
      pediatricWeight : { required },
      apgar1m         : { required },
      apgar5m         : { required },
      status          : { required },
      injury          : { required },
      causeofdeath    : { requiredIf: requiredIfInfantDeath},
      specificcause   : { requiredIf: requiredIfInfantDeath},
      anomalies       : { required },
      anomalyOthers   : { requiredIf: requiredIfInfantHasAnomaly}
    }
  }
}
